function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ClickOutside from 'vue-click-outside';
import Vue from 'vue';
import VTooltip from 'v-tooltip';
import { PopoverMenu, Multiselect, Actions, ActionButton } from '@nextcloud/vue';
import UserRowSimple from './UserRowSimple';
import UserRowMixin from '../../mixins/UserRowMixin';
Vue.use(VTooltip);
export default {
  name: 'UserRow',
  components: {
    UserRowSimple: UserRowSimple,
    PopoverMenu: PopoverMenu,
    Actions: Actions,
    ActionButton: ActionButton,
    Multiselect: Multiselect
  },
  directives: {
    ClickOutside: ClickOutside
  },
  mixins: [UserRowMixin],
  props: {
    user: {
      type: Object,
      required: true
    },
    settings: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    groups: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    subAdminsGroups: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    quotaOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    languages: {
      type: Array,
      required: true
    },
    externalActions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      rand: parseInt(Math.random() * 1000),
      openedMenu: false,
      feedbackMessage: '',
      editing: false,
      loading: {
        all: false,
        displayName: false,
        password: false,
        mailAddress: false,
        groups: false,
        subadmins: false,
        quota: false,
        delete: false,
        disable: false,
        languages: false,
        wipe: false
      }
    };
  },
  computed: {
    /* USER POPOVERMENU ACTIONS */
    userActions: function userActions() {
      var actions = [{
        icon: 'icon-delete',
        text: t('settings', 'Delete user'),
        action: this.deleteUser
      }, {
        icon: 'icon-delete',
        text: t('settings', 'Wipe all devices'),
        action: this.wipeUserDevices
      }, {
        icon: this.user.enabled ? 'icon-close' : 'icon-add',
        text: this.user.enabled ? t('settings', 'Disable user') : t('settings', 'Enable user'),
        action: this.enableDisableUser
      }];

      if (this.user.email !== null && this.user.email !== '') {
        actions.push({
          icon: 'icon-mail',
          text: t('settings', 'Resend welcome email'),
          action: this.sendWelcomeMail
        });
      }

      return actions.concat(this.externalActions);
    }
  },
  methods: {
    /* MENU HANDLING */
    toggleMenu: function toggleMenu() {
      this.openedMenu = !this.openedMenu;
    },
    hideMenu: function hideMenu() {
      this.openedMenu = false;
    },
    wipeUserDevices: function wipeUserDevices() {
      var _this = this;

      var userid = this.user.id;
      OC.dialogs.confirmDestructive(t('settings', 'In case of lost device or exiting the organization, this can remotely wipe the Nextcloud data from all devices associated with {userid}. Only works if the devices are connected to the internet.', {
        userid: userid
      }), t('settings', 'Remote wipe of devices'), {
        type: OC.dialogs.YES_NO_BUTTONS,
        confirm: t('settings', 'Wipe {userid}\'s devices', {
          userid: userid
        }),
        confirmClasses: 'error',
        cancel: t('settings', 'Cancel')
      }, function (result) {
        if (result) {
          _this.loading.wipe = true;
          _this.loading.all = true;

          _this.$store.dispatch('wipeUserDevices', userid).then(function () {
            _this.loading.wipe = false;
            _this.loading.all = false;
          });
        }
      }, true);
    },
    deleteUser: function deleteUser() {
      var _this2 = this;

      var userid = this.user.id;
      OC.dialogs.confirmDestructive(t('settings', 'Fully delete {userid}\'s account including all their personal files, app data, etc.', {
        userid: userid
      }), t('settings', 'Account deletion'), {
        type: OC.dialogs.YES_NO_BUTTONS,
        confirm: t('settings', 'Delete {userid}\'s account', {
          userid: userid
        }),
        confirmClasses: 'error',
        cancel: t('settings', 'Cancel')
      }, function (result) {
        if (result) {
          _this2.loading.delete = true;
          _this2.loading.all = true;
          return _this2.$store.dispatch('deleteUser', userid).then(function () {
            _this2.loading.delete = false;
            _this2.loading.all = false;
          });
        }
      }, true);
    },
    enableDisableUser: function enableDisableUser() {
      var _this3 = this;

      this.loading.delete = true;
      this.loading.all = true;
      var userid = this.user.id;
      var enabled = !this.user.enabled;
      return this.$store.dispatch('enableDisableUser', {
        userid: userid,
        enabled: enabled
      }).then(function () {
        _this3.loading.delete = false;
        _this3.loading.all = false;
      });
    },

    /**
    	 * Set user displayName
    	 *
    	 * @param {string} displayName The display name
    	 */
    updateDisplayName: function updateDisplayName() {
      var _this4 = this;

      var displayName = this.$refs.displayName.value;
      this.loading.displayName = true;
      this.$store.dispatch('setUserData', {
        userid: this.user.id,
        key: 'displayname',
        value: displayName
      }).then(function () {
        _this4.loading.displayName = false;
        _this4.$refs.displayName.value = displayName;
      });
    },

    /**
    	 * Set user password
    	 *
    	 * @param {string} password The email adress
    	 */
    updatePassword: function updatePassword() {
      var _this5 = this;

      var password = this.$refs.password.value;
      this.loading.password = true;
      this.$store.dispatch('setUserData', {
        userid: this.user.id,
        key: 'password',
        value: password
      }).then(function () {
        _this5.loading.password = false;
        _this5.$refs.password.value = ''; // empty & show placeholder
      });
    },

    /**
    	 * Set user mailAddress
    	 *
    	 * @param {string} mailAddress The email adress
    	 */
    updateEmail: function updateEmail() {
      var _this6 = this;

      var mailAddress = this.$refs.mailAddress.value;
      this.loading.mailAddress = true;
      this.$store.dispatch('setUserData', {
        userid: this.user.id,
        key: 'email',
        value: mailAddress
      }).then(function () {
        _this6.loading.mailAddress = false;
        _this6.$refs.mailAddress.value = mailAddress;
      });
    },

    /**
    	 * Create a new group and add user to it
    	 *
    	 * @param {string} gid Group id
    	 */
    createGroup: function createGroup(gid) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var userid;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this7.loading = {
                  groups: true,
                  subadmins: true
                };
                _context.prev = 1;
                _context.next = 4;
                return _this7.$store.dispatch('addGroup', gid);

              case 4:
                userid = _this7.user.id;
                _context.next = 7;
                return _this7.$store.dispatch('addUserGroup', {
                  userid: userid,
                  gid: gid
                });

              case 7:
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                console.error(_context.t0);

              case 12:
                _context.prev = 12;
                _this7.loading = {
                  groups: false,
                  subadmins: false
                };
                return _context.finish(12);

              case 15:
                return _context.abrupt("return", _this7.$store.getters.getGroups[_this7.groups.length]);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 9, 12, 15]]);
      }))();
    },

    /**
    	 * Add user to group
    	 *
    	 * @param {object} group Group object
    	 */
    addUserGroup: function addUserGroup(group) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var userid, gid;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(group.canAdd === false)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", false);

              case 2:
                _this8.loading.groups = true;
                userid = _this8.user.id;
                gid = group.id;
                _context2.prev = 5;
                _context2.next = 8;
                return _this8.$store.dispatch('addUserGroup', {
                  userid: userid,
                  gid: gid
                });

              case 8:
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](5);
                console.error(_context2.t0);

              case 13:
                _context2.prev = 13;
                _this8.loading.groups = false;
                return _context2.finish(13);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[5, 10, 13, 16]]);
      }))();
    },

    /**
    	 * Remove user from group
    	 *
    	 * @param {object} group Group object
    	 */
    removeUserGroup: function removeUserGroup(group) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var userid, gid;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(group.canRemove === false)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", false);

              case 2:
                _this9.loading.groups = true;
                userid = _this9.user.id;
                gid = group.id;
                _context3.prev = 5;
                _context3.next = 8;
                return _this9.$store.dispatch('removeUserGroup', {
                  userid: userid,
                  gid: gid
                });

              case 8:
                _this9.loading.groups = false; // remove user from current list if current list is the removed group

                if (_this9.$route.params.selectedGroup === gid) {
                  _this9.$store.commit('deleteUser', userid);
                }

                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](5);
                _this9.loading.groups = false;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[5, 12]]);
      }))();
    },

    /**
    	 * Add user to group
    	 *
    	 * @param {object} group Group object
    	 */
    addUserSubAdmin: function addUserSubAdmin(group) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var userid, gid;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this10.loading.subadmins = true;
                userid = _this10.user.id;
                gid = group.id;
                _context4.prev = 3;
                _context4.next = 6;
                return _this10.$store.dispatch('addUserSubAdmin', {
                  userid: userid,
                  gid: gid
                });

              case 6:
                _this10.loading.subadmins = false;
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](3);
                console.error(_context4.t0);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[3, 9]]);
      }))();
    },

    /**
    	 * Remove user from group
    	 *
    	 * @param {object} group Group object
    	 */
    removeUserSubAdmin: function removeUserSubAdmin(group) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var userid, gid;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this11.loading.subadmins = true;
                userid = _this11.user.id;
                gid = group.id;
                _context5.prev = 3;
                _context5.next = 6;
                return _this11.$store.dispatch('removeUserSubAdmin', {
                  userid: userid,
                  gid: gid
                });

              case 6:
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](3);
                console.error(_context5.t0);

              case 11:
                _context5.prev = 11;
                _this11.loading.subadmins = false;
                return _context5.finish(11);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[3, 8, 11, 14]]);
      }))();
    },

    /**
    	 * Dispatch quota set request
    	 *
    	 * @param {string|Object} quota Quota in readable format '5 GB' or Object {id: '5 GB', label: '5GB'}
    	 * @returns {string}
    	 */
    setUserQuota: function setUserQuota() {
      var _arguments = arguments,
          _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var quota;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                quota = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 'none';
                _this12.loading.quota = true; // ensure we only send the preset id

                quota = quota.id ? quota.id : quota;
                _context6.prev = 3;
                _context6.next = 6;
                return _this12.$store.dispatch('setUserData', {
                  userid: _this12.user.id,
                  key: 'quota',
                  value: quota
                });

              case 6:
                _context6.next = 11;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](3);
                console.error(_context6.t0);

              case 11:
                _context6.prev = 11;
                _this12.loading.quota = false;
                return _context6.finish(11);

              case 14:
                return _context6.abrupt("return", quota);

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[3, 8, 11, 14]]);
      }))();
    },

    /**
    	 * Validate quota string to make sure it's a valid human file size
    	 *
    	 * @param {string} quota Quota in readable format '5 GB'
    	 * @returns {Promise|boolean}
    	 */
    validateQuota: function validateQuota(quota) {
      // only used for new presets sent through @Tag
      var validQuota = OC.Util.computerFileSize(quota);

      if (validQuota !== null && validQuota >= 0) {
        // unify format output
        return this.setUserQuota(OC.Util.humanFileSize(OC.Util.computerFileSize(quota)));
      } // if no valid do not change


      return false;
    },

    /**
    	 * Dispatch language set request
    	 *
    	 * @param {Object} lang language object {code:'en', name:'English'}
    	 * @returns {Object}
    	 */
    setUserLanguage: function setUserLanguage(lang) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this13.loading.languages = true; // ensure we only send the preset id

                _context7.prev = 1;
                _context7.next = 4;
                return _this13.$store.dispatch('setUserData', {
                  userid: _this13.user.id,
                  key: 'language',
                  value: lang.code
                });

              case 4:
                _context7.next = 9;
                break;

              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7["catch"](1);
                console.error(_context7.t0);

              case 9:
                _context7.prev = 9;
                _this13.loading.languages = false;
                return _context7.finish(9);

              case 12:
                return _context7.abrupt("return", lang);

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[1, 6, 9, 12]]);
      }))();
    },

    /**
    	 * Dispatch new welcome mail request
    	 */
    sendWelcomeMail: function sendWelcomeMail() {
      var _this14 = this;

      this.loading.all = true;
      this.$store.dispatch('sendWelcomeMail', this.user.id).then(function (success) {
        if (success) {
          // Show feedback to indicate the success
          _this14.feedbackMessage = t('setting', 'Welcome mail sent!');
          setTimeout(function () {
            _this14.feedbackMessage = '';
          }, 2000);
        }

        _this14.loading.all = false;
      });
    }
  }
};